import { useWorkOrderRecord } from "@/app/ProDrivers/WorkOrders/Hooks/useWorkOrderRecord";
import { WorkOrderAssignmentThreads } from "@/app/ProDrivers/WorkOrders/Components/WorkOrderAssignmentThreads";
import { useParams } from "@tanstack/react-router";
import { useRef } from "react";
import { useFillViewportHeight } from "@/app/Threads/hooks/useFillViewportHeight";

export function WorkOrderMessagesScreen() {
  const workOrder = useWorkOrderRecord();
  const { threadId } = useParams({ strict: false });
  const containerRef = useRef<HTMLDivElement>(null);
  const height = useFillViewportHeight(containerRef);

  return (
    <div
      ref={containerRef}
      style={height !== null ? { height: `${height}px` } : undefined}
      className="-mb-96 mt-4 flex h-[calc(100dvh-380px)] min-h-[400px] overflow-hidden rounded-lg border border-gray-200 bg-white"
    >
      <WorkOrderAssignmentThreads
        workOrderId={workOrder.id}
        selectedId={threadId ?? null}
      />
    </div>
  );
}
